import { Tooltip } from "@mui/material";
import React, { ReactElement } from "react";

import { ProductPerspective } from "../../hooks/use-product-presentations";
import { classNames } from "../../utils/classes";

export type PerspectiveListProps = {
  perspectives: ProductPerspective[];
  gridSize: number;
  selectedPerspectiveId?: string;
  onSelectPerspective(presentation: ProductPerspective): void;
};

export default function PerspectiveList(
  props: PerspectiveListProps,
): ReactElement {
  const { gridSize, perspectives, selectedPerspectiveId, onSelectPerspective } =
    props;

  return (
    <div className="flex flex-wrap justify-between gap-3 overflow-y-scroll p-5">
      {perspectives.map((item) => (
        <div
          style={{ width: `${gridSize}px` }}
          key={item.id}
          className="cursor-pointer"
        >
          <button
            type="button"
            className="flex w-full flex-col space-y-2"
            onClick={() => onSelectPerspective(item)}
          >
            <img
              src={item.thumbnailUrl}
              alt={item.name || ""}
              style={{
                width: "100%",
                aspectRatio: "1/1",
              }}
              className={classNames(
                "rounded object-contain",
                selectedPerspectiveId === item.id
                  ? "ring-4 ring-company ring-offset-4"
                  : "",
              )}
            />
            <Tooltip title={item.name} placement="bottom" arrow>
              <p className="max-w-full truncate text-sm text-gray-500">
                {item.name}
              </p>
            </Tooltip>
          </button>
        </div>
      ))}
    </div>
  );
}
